import { DisputeTypes } from "utils/constants";
import { Disputes } from "./disputes";
export function BackofficeSuperagentDisputes() {
  return <Disputes disputeType={DisputeTypes.BackofficeSuperAgent} />;
}
